import { useMemo, useState } from "react";

import { isNotEmpty, isPresent } from "neetocist";
import { withEventTargetValue } from "neetocommons/utils/general";
import { Search } from "neetoicons";
import { Input, Typography } from "neetoui";
import { assoc } from "ramda";
import { useTranslation } from "react-i18next";

import Body from "components/Builder/Body";

import SectionsContainer from "./SectionsContainer";
import TitleBar from "./TitleBar";

const ElementList = ({
  setVisiblePanel,
  elementSections = [],
  onSelect,
  isDragElementsDisabled,
  isAddingNewElement,
}) => {
  const { t } = useTranslation();
  const [searchString, setSearchString] = useState("");

  const filteredSections = useMemo(() => {
    let elementIndex = 0;

    return elementSections
      .map(section => ({
        ...section,
        elements: section.elements
          .filter(element =>
            element.label.toLowerCase().includes(searchString.toLowerCase())
          )
          .map(element => assoc("elementIndex", elementIndex++, element)),
      }))
      .filter(section =>
        isPresent(searchString) ? isNotEmpty(section.elements) : true
      );
  }, [searchString, elementSections]);

  return (
    <>
      <TitleBar {...{ setVisiblePanel }} />
      <div className="mb-1 px-6">
        <Typography className="mb-3" style="body3">
          {t("neetoMolecules.builderSidebar.addNewElementDescription")}
        </Typography>
        <Input
          autoFocus
          data-testid="elements-panel-search-field"
          placeholder={t("neetoMolecules.builderSidebar.searchElements")}
          prefix={<Search />}
          type="search"
          value={searchString}
          onChange={withEventTargetValue(setSearchString)}
        />
      </div>
      <Body data-testid="elements-container" size="small">
        <SectionsContainer
          {...{
            filteredSections,
            isAddingNewElement,
            isDragElementsDisabled,
            onSelect,
            setVisiblePanel,
          }}
        />
      </Body>
    </>
  );
};

export default ElementList;
